module.exports = __webpack_public_path__ + "img/points.b3c3cb74.svg";